import { render, staticRenderFns } from "./OwnStats.vue?vue&type=template&id=9c8a466c&scoped=true"
import script from "./OwnStats.vue?vue&type=script&lang=js"
export * from "./OwnStats.vue?vue&type=script&lang=js"
import style0 from "./OwnStats.vue?vue&type=style&index=0&id=9c8a466c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8a466c",
  null
  
)

export default component.exports